import { useEffect, useState } from "react";
export const useDidomiConsents = () => {
    const [didomiPurposesConsent, setDidomiPurposesConsent] = useState([]);
    const [didomiConsentHasChanged, setDidomiConsentHasChanged] = useState(false);
    const [isDidomiReady, setDidomiReady] = useState(false);
    useEffect(() => {
        window.didomiOnReady = window.didomiOnReady || [];
        window.didomiOnReady.push(() => {
            var _a, _b;
            if (!((_a = window.Didomi) === null || _a === void 0 ? void 0 : _a.shouldConsentBeCollected())) {
                setDidomiReady(true);
                setDidomiPurposesConsent((_b = window.Didomi) === null || _b === void 0 ? void 0 : _b.getUserStatus().purposes.consent.enabled);
            }
        });
        window.didomiEventListeners = window.didomiEventListeners || [];
        window.didomiEventListeners.push({
            event: "consent.changed",
            listener: (context) => {
                if (context.action === "click") {
                    setDidomiPurposesConsent(window.Didomi.getUserStatus().purposes.consent.enabled);
                    setDidomiConsentHasChanged(true);
                }
            },
        });
    }, []);
    return { isDidomiReady, didomiPurposesConsent, didomiConsentHasChanged };
};
